import styles from "./StepProgressBar.module.css";
import React from "react";
import Steps from "../../../utils/OggettiUtili"
import Button from "../../../components/button/Button";
import history from "../../../utils/History";
import Modale from "../../../components/modale/Modale";

export class StepProgressBar extends React.Component {

    state = {
        progressBar: ""
    }

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this)
        this.selectStep = this.selectStep.bind(this)
    }

    componentDidMount() {
        this.selectStep()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.infoSchedaSpeciale !== this.props.infoSchedaSpeciale) {
            this.selectStep()
        } else if (prevProps.pagina !== this.props.pagina) {
            this.selectStep()
        }
    }

    onClick(nomeStep) {
        let path = "/wizardSegnalazione"
        history.push({
            pathname: path,
            state: {
                currentState: this.props.isArchiviato ? nomeStep.currentTarget.id : nomeStep
            }
        })
    }

    selectStep() {
        let ret = []
        let steps = Steps.Steps

        if (((this.props.listaSezioni && this.props.listaSezioni.length === 0) || (this.props.listaSezioni && this.props.listaSezioni === "00")) && this.props.datiCompletiECorretti[0] && this.props.datiCompletiECorretti[0].completo) {
            steps = Steps.StepsRidotti
        }

        let numeroStep = 1
        let i = 0
        for (let key in steps) {

            if(key === "SCHEDA_SPECIALE" && (this.props.infoSchedaSpeciale && !this.props.infoSchedaSpeciale.idSchedaSpeciale)){
                let li =
                    <div/>
                ret.push(li)
            }
            else if (key === "SCHEDA_SPECIALE_ESITO_TBC" && (!this.props.esitoTbc)) {
                let li =
                    <div/>
                ret.push(li)
            }
            else if (this.props.pagina === key) {
                let li =
                    <div className="d-inline-flex align-items-center">
                        <div className={styles.active.concat(" " + styles.pallino + " d-inline-block")}>
                            <p className={styles.testoPallino}>{numeroStep}</p>
                        </div>
                        <div className={styles.testo.concat(" d-inline-block ")}>

                            {key === "SCHEDA_SPECIALE" && (this.props.codiceMalattia === "037" || this.props.codiceMalattia === "0270") ? "CARICAMENTO SCHEDA CARTACEA" : steps[key]}


                        </div>
                    </div>
                ret.push(li)
            } else if (this.props.datiCompletiECorretti && this.props.datiCompletiECorretti.length > 0 && this.props.datiCompletiECorretti[i].completo === true && this.props.pagina !== key) {
                let li = this.props.isArchiviato ?
                    <div className="d-inline-flex align-items-center">
                        <Button id={key}
                                className={styles.active.concat(" " + styles.pallino + " d-inline-block")}
                                text={<p className={styles.testoPallino}><span>&#10003;</span></p>}
                                onClick={this.onClick}
                        />
                        <div className={styles.testo.concat(" d-inline-block ")}>

                            {key === "SCHEDA_SPECIALE" && (this.props.codiceMalattia === "037" || this.props.codiceMalattia === "0270") ? "CARICAMENTO SCHEDA CARTACEA" : steps[key]}

                        </div>
                    </div> :
                    <div className="d-inline-flex align-items-center">
                        <Modale
                            id={key}
                            typeModal="modalConsenso"
                            modalText={"Procedendo le modifiche effettuate, non salvate, verranno perse"}
                            classes={styles.active.concat(" " + styles.pallino + " d-inline-block")}
                            text={<p className={styles.testoPallino}><span>&#10003;</span></p>}
                            title={"Conferma e prosegui"}
                            textButtonOk={"Si"}
                            textButtonKo={"No"}
                            progressBar={true}
                            value={key}
                            onClickCustom={this.onClick}/>
                        <div className={styles.testo.concat(" d-inline-block ")}>

                            {key === "SCHEDA_SPECIALE" && (this.props.codiceMalattia === "037" || this.props.codiceMalattia === "0270") ? "CARICAMENTO SCHEDA CARTACEA" : steps[key]}

                        </div>
                    </div>
                ret.push(li)
            } else {
                let li =
                    <div className="d-inline-flex align-items-center">
                        <div className={styles.pallino.concat(" d-inline-block")}>{numeroStep}</div>
                        <div className={styles.testo.concat(" d-inline-block ")}>
                            {key === "SCHEDA_SPECIALE" && (this.props.codiceMalattia === "037" || this.props.codiceMalattia === "0270") ? "CARICAMENTO SCHEDA CARTACEA" : steps[key]}
                        </div>
                    </div>
                ret.push(li)
            }
            numeroStep++
            i++
        }

        return this.setState({progressBar: ret})
    }

    render() {
        return (
            <div className={styles.container}>
                <ul className={styles.progressbar}>
                    {this.state.progressBar}
                </ul>
            </div>
        );
    }
}

